import { render, staticRenderFns } from "./BuildingInsurance.vue?vue&type=template&id=5f2b87b0&scoped=true"
import script from "./BuildingInsurance.vue?vue&type=script&lang=ts"
export * from "./BuildingInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b87b0",
  null
  
)

export default component.exports